import { httpClient } from '@bcba/client-auth';
import { ProvinceWithLocalitiesSerializer } from '@bcba/serializers';

const basePath = '/provinces/';

export const getProvinceLocalities = async (
  uuid: string,
  localitySearchValue: string,
): Promise<ProvinceWithLocalitiesSerializer['localities']> => {
  const response = await httpClient.get<ProvinceWithLocalitiesSerializer>(
    basePath + uuid,
    { params: { localitySearchValue } },
  );

  return response?.data?.localities;
};
